<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-md-2">
          <label>Assign From Date</label>
          <date-picker v-model="assignFrom" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="assignFrom"
                     v-model="assignFrom"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label>Assign To Date</label>
          <date-picker v-model="assignTo" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="assignTo"
                     v-model="assignTo"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label>Assign No</label>
          <InputText v-model="assignNo" disabled/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Assign To</label>
          <Dropdown
            v-model="employee"
            :options="employeeDropdownList"
            optionLabel="name"
            class="dropDown"
            :filter="true"
            placeholder="Select Employee"
          />
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Store</label>
          <Dropdown
            v-model="warehouse"
            :options="warehouseLists"
            optionLabel="name"
            id="warehouse"
            :filter="true"
            placeholder="Select warehouse"
            :showClear="true"
          />
        </div>
        <div class="p-fluid p-formgrid p-grid p-col-12 p-mt-2">
          <div class="p-field p-col-12 p-md-3">
            <label>Item<b style="color:red;">*</b></label>
            <!-- <Dropdown
              v-model="item"
              :options="itemMasterListByItemType"
              optionLabel="name"
              class="dropDown"
              :filter="true"
              placeholder="Select Item"
            /> -->
               <AutoComplete v-model="item" filterMatchMode='contains' id="itm"
                 :suggestions="filteredItems" @complete="searchItem($event)"
                  field="name" ref="itm">
                 </AutoComplete>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label>Quantity</label>
            <InputNumber id="minmaxfraction" onfocus="if (this.value === '0.00'){this.value = ''}" v-model="quantity"
                         :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button class="p-button-raised p-button-rounded" id="action" @click.prevent="addItemToDTO"
                    :label="!editDTO?'Add':'Update'"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="editDTO" class="p-button-raised p-button-danger" id="action"
                    @click.prevent="itemDTOReset" label="Cancel"/>
          </div>
        </div>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
            <div class="scrollable">
              <table class="table table-bordered ">
                <thead>
                <tr>
                  <th style="text-align: center">SN</th>
                  <th style="text-align: center">Item Name</th>
                  <th style="text-align: center">Quantity</th>
                  <th scope="col">Unit</th>
                  
                  <th style="text-align: center">Action</th>
                </tr>
                </thead>
                <tbody v-for="(item,index) in inventoryInOutDetailList " :key="index">
                <tr>
                  <td style="text-align: center">{{ index + 1 }}</td>
                  <td>{{item.itemMaster.itemNameWithCode}}</td>
                  <td>{{ item.quantity }}</td>
                   <td style="text-align:right">{{item.itemMaster.unitName}}</td>
                  <td>
                    <Button class="p-button-raised p-button-success"
                            @click.prevent="editItemFromDTO(item, index)"
                            icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger" v-if="editDTO"
                            @click.prevent="deleteItemFromDTO(item, index)" disabled icon="pi pi-trash"/>
                    <Button class="p-button-raised p-button-danger" v-else-if="!editDTO"
                            @click.prevent="deleteItemFromDTO(item, index)" icon="pi pi-trash"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <hr>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 15em;">Total:</b>
              </div>
              <div class="p-field p-col-12 p-md-4"></div>
              <div class="p-field p-col-12 p-md-2">
                <b style="margin-left: 16em;">{{ totalQty }}</b>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-col-12">
        <div class="p-field p-col-12 p-md-3">
          <label>Narration</label>
          <Textarea rows="6" v-model="narration"/>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-col-12">
        <div class="p-field p-col-12 p-md-8"></div>
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised p-button-success" :label="!editing?'Save':'Update'"
          @click="addinventoryAssign"
                  icon="pi pi-save"/>
        </div>
        <div cclass="p-field p-col-12 p-md-1">
          <Button class="p-button-raised p-button-warning"
                  icon="pi pi-refresh" label="Reset"/>
        </div>
        <div class="p-field p-col-12 p-md-1" v-if="inventoryAssignEntry!=undefined">
          <Button class="p-button-raised p-button-danger" @click="goBack()" label="Cancel"/>
         </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import AutoComplete from 'primevue/autocomplete'

export default {
  name: 'inventoryAssignEntry',
  props: ['inventoryAssignEntry'],
  data() {
    return {
      loading: false,
      englishDateEnabled: true,
      assignFrom: null,
      assignTo: null,
      employee: null,
      warehouse: null,
      quantity: 0.00,
      filteredItems: null,
      assignNo: 0,
      assignHeaderId: null,
      item: null,
      narration: '',
      // itemMasterListByItemType: [{name: 'ABC'}, {name: 'XYZ'}],
      editDTO: false,
      id: null,
      remarks: '',
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      editing: false
    }
  },
  computed: {
    employeeDropdownList() {
      return this.$store.state.hr.employeeDropdownList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    totalQty() {
      let totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
      }
      return totalQty
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.findEmployeeDropdown()
    this.findWarehouseList()
    this.maxAssignNo()
    this.itemMasterListByItemTypes()
    if (this.inventoryAssignEntry !== undefined) {
      this.editInventoryAssign()
    }
  },
  methods: {
    async findEmployeeDropdown() {
      await this.$store.dispatch('loadEmployeeDropdownList')
    },
    async findWarehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemType')
    },
    addItemToDTO() {
      let item = {
        item: this.item,
        itemId: this.item.id,
        quantity: this.quantity
      }
      if (!this.editDTO) {
        this.inventoryInOutDetailList.push({...item})
      } else {
        this.inventoryInOutDetailList.splice(this.index, 1, {...item})
      }
      this.itemDTOReset()
    },
    async maxAssignNo() {
      let response = await this.$store.dispatch('maxAssignNo')
      if (this.inventoryAssignEntry === undefined) {
        this.assignNo = response.data.data
        this.purchaseMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.assignNo = this.inventoryAssignEntry.assignNo
        this.purchaseMessage = this.inventoryAssignEntry.remarks
      }
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    itemDTOreset() {
      this.item = ''
      this.quantity = 0
      this.total = 0
      this.editDto = false
      this.id = null
    },
    editItemFromDTO(data, index) {
      this.itemDTOReset()
      this.editDTO = true
      this.item = data.itemMaster
      this.index = index
      this.quantity = data.quantity
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    async addinventoryAssign() {
      if (this.assignFrom === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter Assign date!', life: 10000})
        return
      }
      let response = ''
      let inventoryAssignEntry = {
        assignNo: this.assignNo,
        warehouseId: this.warehouse.id,
        assignFrom: this.assignFrom,
        assignDateNepali: this.assignFrom,
        assignTo: this.assignTo,
        assignToDateNepali: this.assignTo,
        employeeId: this.employee.id,
        // referenceNumber: this.refNo,
        fiscalYearId: this.$store.state.fyId,
        id: this.assignHeaderId,
        remarks: this.narration,
        employeeInventoryAssignDetailsDTOList: this.inventoryInOutDetailList
      }
      if (inventoryAssignEntry.employeeInventoryAssignDetailsDTOList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item !', life: 10000})
        return
      }
      if (this.inventoryAssignEntry === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addAssignInventory', inventoryAssignEntry)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateAssignInventory', inventoryAssignEntry)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        // this.$emit('update-message', response.data.message)
        this.maxAssignNo()
        this.itemMasterListByItemTypes()
        // if (!this.editing && response.data.data.id > 0) {
        //   this.openPrintDialog(response.data.data.id)
        // }
        this.reset()
        // this.focusAfterSave()
        this.saved = true
        this.headerId = response.data.data.id
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async editInventoryAssign() {
      this.editing = true
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.assignFrom = this.inventoryAssignEntry.assignDateNepali
        this.assignTo = this.inventoryAssignEntry.assignToDateNepali
      } else {
        this.assignFrom = this.inventoryAssignEntry.assignFrom
        this.assignTo = this.inventoryAssignEntry.assignTo
      }
      this.warehouse = this.inventoryAssignEntry.warehouse
      this.narration = this.inventoryAssignEntry.remarks
      this.employee = this.inventoryAssignEntry.employee
      this.assignHeaderId = this.inventoryAssignEntry.id
      this.assignNo = this.inventoryAssignEntry.assignNo
      this.inventoryInOutDetailList = this.inventoryAssignEntry.employeeInventoryAssignDetailsDTOList
      // // debugger
    },
    reset() {
      this.itemDTOreset()
      this.warehouse = null
      this.employee = null
      this.item = null
      this.editItemFromDTO = false
    },
    // editAssignHeader() {
    //   this.editing = !this.editing
    //   if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
    //     this.assignFrom = this.inventoryAssignEntry.assignDateNepali
    //   } else {
    //     this.assignFrom = this.inventoryAssignEntry.assignDateNepali
    //   }
    //   if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
    //     this.assignTo = this.inventoryAssignEntry.assignToDateNepali
    //   } else {
    //     this.assignTo = this.inventoryAssignEntry.assignDateNepali
    //   }
    //   this.inventoryInOutDetailList = this.inventoryAssignEntry.employeeInventoryAssignDetailsDTOList
    // },
    itemDTOReset() {
      this.item = ''
      this.quantity = 0.00
      this.editDTO = false
      this.id = null
    },
    setNepaliDate() {
      this.assignFrom = this.$store.getters.nepaliNewDate
      this.assignTo = this.$store.getters.nepaliNewDate
    },
    setEnglishDate() {
      this.assignFrom = new Date().toISOString().slice(0, 10)
      this.assignTo = new Date().toISOString().slice(0, 10)
    },
    goBack() {
      // // eslint-disable-next-line no-return-assign
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.inventoryAssignEntry.edit.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#assignFrom').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.assignFrom = $('#assignFrom').val()
        }
      })
      $('#assignTo').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.assignTo = $('#assignFrom').val()
        }
      })
    }
  },
  components: {
    InputMask,
    DatePicker,
    InputText,
    Dropdown,
    InputNumber,
    Button,
    Textarea,
    AutoComplete
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// InventoryAssignEntry.vue?4be365cc